var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c(
        "el-form",
        {
          ref: "listQuery",
          attrs: { model: _vm.listQuery, "label-position": "top" },
        },
        [
          _c("div", { staticClass: "filter-container-content" }, [
            _c(
              "div",
              { staticClass: "filter-container-new box" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.vesselAndVoyage"),
                              prop: "pol",
                            },
                          },
                          [
                            _c("gl-ship-voyage", {
                              on: {
                                handleOpenVessel: _vm.handleOpenVesselSearch,
                              },
                              model: {
                                value: _vm.listQuery,
                                callback: function ($$v) {
                                  _vm.listQuery = $$v
                                },
                                expression: "listQuery",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("home.blNo"), prop: "blNo" },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "50%" },
                                  attrs: { type: "text" },
                                  model: {
                                    value: _vm.listQuery.blNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listQuery, "blNo", $$v)
                                    },
                                    expression: "listQuery.blNo",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-primary",
                                    staticStyle: { "margin-left": "16px" },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.handleSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("home.search")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-plain-primary",
                                    on: { click: _vm.handleReset },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("home.reset")))]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-container-content" }, [
            _c(
              "div",
              { staticClass: "filter-container-new" },
              [
                _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                  _c("i", { staticClass: "el-icon-warning" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "container-content-tips" }, [
                    _vm._v(_vm._s(_vm.$t("exportCostSlipUpload.tips"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.releaseWay"),
                              prop: "releaseWay",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.listQuery.releaseWay,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "releaseWay", $$v)
                                  },
                                  expression: "listQuery.releaseWay",
                                },
                              },
                              _vm._l(_vm.releaseWayList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 15 } },
                      [
                        _c(
                          "el-form-item",
                          { staticStyle: { position: "relative" } },
                          [
                            _c(
                              "div",
                              { staticClass: "btn-box" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-primary",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.handleRelease },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("home.releaseApply")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-primary",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.handleResetView },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("home.releaseView")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-primary",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.handleReleaseViewUpload },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.releaseViewUpload"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.porFormat"),
                              "label-position": "top",
                              prop: "porFormat",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.listQuery.porFormat,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "porFormat", $$v)
                                  },
                                  expression: "listQuery.porFormat",
                                },
                              },
                              _vm._l(_vm.reportList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.polFormat"),
                              prop: "polFormat",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.listQuery.polFormat,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "polFormat", $$v)
                                  },
                                  expression: "listQuery.polFormat",
                                },
                              },
                              _vm._l(_vm.reportList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.podFormat"),
                              prop: "podFormat",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.listQuery.podFormat,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "podFormat", $$v)
                                  },
                                  expression: "listQuery.podFormat",
                                },
                              },
                              _vm._l(_vm.reportList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.delFormat"),
                              prop: "delFormat",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.listQuery.delFormat,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "delFormat", $$v)
                                  },
                                  expression: "listQuery.delFormat",
                                },
                              },
                              _vm._l(_vm.reportList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          { staticClass: "table-container-new" },
          [
            _c(
              "hot-table",
              {
                ref: "hotTable",
                attrs: {
                  "data-source": _vm.tableData,
                  settings: _vm.hotSettings,
                  "current-page": _vm.listQuery.currentPage,
                  "page-size": _vm.listQuery.pageSize,
                  "selection-column-title": _vm.$t("home.No"),
                },
              },
              [
                _c("hot-column", {
                  attrs: {
                    data: "blNo",
                    width: "100",
                    title: _vm.$t("home.blNo"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "deliveryMethod",
                      title: _vm.$t("home.releaseWay"),
                      "class-name": "htCenter",
                      "filter-list": _vm.releaseWayList,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      width: "200",
                      data: "logState",
                      title: _vm.$t("home.logStatus"),
                      "class-name": "htCenter",
                      "filter-list": _vm.logStateList,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    width: "200",
                    data: "logInformation",
                    title: _vm.$t("home.logInfomation"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "deliveryDocumentMethod",
                      title: _vm.$t("home.deliveryDocumentMethod"),
                      "class-name": "htCenter",
                      "filter-list": _vm.deliveryList,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "releaseStatus",
                      title: _vm.$t("home.releaseStatus"),
                      "class-name": "htCenter",
                      "filter-list": _vm.releaseStatus,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "por",
                    title: _vm.$t("home.por"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "porFormat",
                      title: _vm.$t("home.porFormat"),
                      "class-name": "htCenter",
                      "filter-list": _vm.reportList,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "pol",
                    title: _vm.$t("home.pol"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "polFormat",
                      title: _vm.$t("home.polFormat"),
                      "class-name": "htCenter",
                      "filter-list": _vm.reportList,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "pod",
                    title: _vm.$t("home.pod"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "podFormat",
                      title: _vm.$t("home.podFormat"),
                      "class-name": "htCenter",
                      "filter-list": _vm.reportList,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hot-column", {
                  attrs: {
                    data: "del",
                    title: _vm.$t("home.del"),
                    "class-name": "htCenter",
                  },
                }),
                _vm._v(" "),
                _c(
                  "hot-column",
                  {
                    attrs: {
                      data: "delFormat",
                      title: _vm.$t("home.delFormat"),
                      "class-name": "htCenter",
                      "filter-list": _vm.reportList,
                    },
                  },
                  [
                    _c("filter-column", {
                      attrs: {
                        "hot-renderer": "",
                        "filter-value": "codeValue",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              staticClass: "pagePanel",
              staticStyle: { "text-align": "left" },
              attrs: {
                total: _vm.total,
                page: _vm.listQuery.currentPage,
                limit: _vm.listQuery.pageSize,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.listQuery, "currentPage", $event)
                },
                "update:limit": function ($event) {
                  return _vm.$set(_vm.listQuery, "pageSize", $event)
                },
                pagination: _vm.handleSearch,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("releaseImportDialog", {
        ref: "releaseImportDialog",
        attrs: {
          "destroy-on-close": true,
          width: "40%",
          bookingHeadWebId: _vm.idData,
          visible: _vm.releaseImportDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.releaseImportDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("sailSchedule", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChange,
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }